const AvatarsUtils = () => {
    
    const getAvatarLabelFromFirstNameAndLastName = (firstName, lastName) => {
        if (firstName == '' && lastName == '') {
            return '?'
        }
        return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`
    }
    const getTooltipValueForUser = (user, activeUser) => {
        if (user.email == '') {
            return 'Deleted account'
        }
        return `${user.first_name} ${user.last_name} (${user.email})${activeUser && user.email===activeUser.email ? ' - Currently in use' : ''}`
    }
    
    return { getAvatarLabelFromFirstNameAndLastName, getTooltipValueForUser }
}

export default AvatarsUtils